<template>
  <div
    v-if="profile"
    class="passenger-block-container"
  >
    <FlashMessage />
    <div class="passenger-block-item"
      v-for="(person, index) in profile.paxnames"
      :key="index"
    >
      <Member
        :person="person"
        :person-index="index"
      />
    </div>  
  </div>
</template>

<script>
import FlashMessage from "@/partials/flash-message"
import Member from './member'
export default {
  components: {
    Member,
    FlashMessage
  },
  props: {
    profile: {
      type: Object,
      default: null
    }
  }  
};
</script>

<style>
@import "./styles.scss";
</style>
